export enum OpoAction {
    Edit = 1,
    Delete = 2,
    Contacts = 3,
    Files = 4,
    OpenPortal = 5
}